import React from 'react';
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "../../Components/Common/ChartsDynamicColor";

const PortfolioCharts = ({ dataColors, series }) => {
    var donutchartportfolioColors = getChartColorsArray(dataColors);

    var options = {
        labels: ["Bitcoin", "Ethereum", "Litecoin", "Dash"],
        chart: {
            type: "donut",
            height: 224,
        },

        plotOptions: {
            pie: {
                size: 100,
                offsetX: 0,
                offsetY: 0,
                donut: {
                    size: "70%",
                    labels: {
                        show: true,
                        name: {
                            show: true,
                            fontSize: '18px',
                            offsetY: -5,
                        },
                        value: {
                            show: true,
                            fontSize: '20px',
                            color: '#343a40',
                            fontWeight: 500,
                            offsetY: 5,
                            formatter: function (val) {
                                return "$" + val;
                            }
                        },
                        total: {
                            show: true,
                            fontSize: '13px',
                            label: 'Total value',
                            color: '#9599ad',
                            fontWeight: 500,
                            formatter: function (w) {
                                return "$" + w.globals.seriesTotals.reduce(function (a, b) {
                                    return a + b;
                                }, 0);
                            }
                        }
                    }
                },
            },
        },
        dataLabels: {
            enabled: false,
        },
        legend: {
            show: false,
        },
        yaxis: {
            labels: {
                formatter: function (value) {
                    return "$" + value;
                }
            }
        },
        stroke: {
            lineCap: "round",
            width: 2
        },
        colors: donutchartportfolioColors,
    };
    return (
        <React.Fragment>
            <ReactApexChart dir="ltr"
                options={options}
                // series={series}
                series={series.length ? series : [{ data: [] }]}
                type="donut"
                height="224"
                className="apex-charts"
            />
        </React.Fragment>
    );
};

const MarkerCharts = ({ dataColors, series, predictions = [] }) => {
    var MarketchartColors = getChartColorsArray(dataColors);

    // Debug: Log predictions received
    console.log('MarkerCharts received predictions:', predictions);
    console.log('Series data:', series);

    // Create annotations for prediction triangles
    const createPredictionAnnotations = () => {
        if (!predictions || predictions.length === 0) {
            console.log('No predictions to display');
            return { points: [], xaxis: [], yaxis: [] };
        }
        
        console.log('Creating annotations for', predictions.length, 'predictions');
        
        const points = [];
        const xaxis = [];
        const yaxis = [];
        
        predictions.forEach((prediction, index) => {
            console.log(`Processing prediction ${index + 1}:`, prediction);
            
            // Safely parse values and ensure they are numbers
            const createDateStr = prediction.create_date;
            const targetDateStr = prediction.target_date;
            const currentPriceStr = prediction.current_price || prediction.priceAtPrediction;
            const predictionHighStr = prediction.prediction_high;
            const predictionLowStr = prediction.prediction_low;
            
            console.log('Raw string values:', {
                createDateStr,
                targetDateStr,
                currentPriceStr,
                predictionHighStr,
                predictionLowStr
            });
            
            // Parse dates
            const createDate = new Date(createDateStr).getTime();
            const targetDate = new Date(targetDateStr).getTime();
            
            // Parse prices - these are large numbers as strings
            const currentPrice = parseFloat(currentPriceStr) || 0;
            const predictionHigh = parseFloat(predictionHighStr) || 0;
            const predictionLow = parseFloat(predictionLowStr) || 0;
            
            console.log(`Parsed values:`, {
                createDate: new Date(createDate).toISOString(),
                targetDate: new Date(targetDate).toISOString(),
                currentPrice,
                predictionHigh,
                predictionLow,
                createDateMs: createDate,
                targetDateMs: targetDate
            });
            
            // Skip this prediction if we don't have valid price data
            if (!predictionHigh || !predictionLow || !currentPrice || !createDate || !targetDate || isNaN(createDate) || isNaN(targetDate)) {
                console.warn('Skipping prediction with invalid data:', {
                    predictionHigh,
                    predictionLow,
                    currentPrice,
                    createDate,
                    targetDate,
                    createDateValid: !isNaN(createDate),
                    targetDateValid: !isNaN(targetDate)
                });
                return;
            }
            
            const color = index % 2 === 0 ? '#FF4757' : '#28a745';
            const fillColor = index % 2 === 0 ? 'rgba(255, 71, 87, 0.1)' : 'rgba(40, 167, 69, 0.1)';
            
            console.log(`Creating annotations with color: ${color}`);
            
            // Create triangle visual effect using vertical lines at both ends
            xaxis.push(
                {
                    x: createDate,
                    strokeDashArray: 0,
                    borderColor: color,
                    borderWidth: 3,
                    label: {
                        text: `P${index + 1}`,
                        position: 'top',
                        offsetY: -5,
                        style: {
                            color: color,
                            background: fillColor,
                            fontSize: '10px',
                            fontWeight: 'bold'
                        }
                    }
                },
                {
                    x: targetDate,
                    strokeDashArray: 0,
                    borderColor: color,
                    borderWidth: 3,
                    label: {
                        text: `Target`,
                        position: 'top',
                        offsetY: -5,
                        style: {
                            color: color,
                            background: fillColor,
                            fontSize: '9px'
                        }
                    }
                }
            );
            
            // Add horizontal lines at target date to show the prediction range
            yaxis.push(
                {
                    y: predictionHigh,
                    y2: predictionHigh,
                    strokeDashArray: 2,
                    borderColor: '#28a745',
                    borderWidth: 2,
                    label: {
                        text: `High: $${predictionHigh.toFixed(0)}`,
                        position: 'right',
                        offsetX: 5,
                        style: {
                            color: '#28a745',
                            background: 'rgba(40, 167, 69, 0.1)',
                            fontSize: '9px'
                        }
                    }
                },
                {
                    y: predictionLow,
                    y2: predictionLow,
                    strokeDashArray: 2,
                    borderColor: '#dc3545',
                    borderWidth: 2,
                    label: {
                        text: `Low: $${predictionLow.toFixed(0)}`,
                        position: 'right',
                        offsetX: 5,
                        style: {
                            color: '#dc3545',
                            background: 'rgba(220, 53, 69, 0.1)',
                            fontSize: '9px'
                        }
                    }
                }
            );
            
            // Add point markers
            points.push(
                // Creation point
                {
                    x: createDate,
                    y: currentPrice,
                    marker: {
                        size: 8,
                        fillColor: color,
                        strokeColor: color,
                        strokeWidth: 2,
                        shape: 'circle'
                    },
                    label: {
                        text: `$${currentPrice.toFixed(0)}`,
                        textAnchor: 'start',
                        offsetX: 10,
                        style: {
                            color: color,
                            background: fillColor,
                            fontSize: '10px',
                            fontWeight: 'bold'
                        }
                    }
                },
                // High target point
                {
                    x: targetDate,
                    y: predictionHigh,
                    marker: {
                        size: 6,
                        fillColor: '#28a745',
                        strokeColor: '#28a745',
                        strokeWidth: 2,
                        shape: 'triangle'
                    }
                },
                // Low target point
                {
                    x: targetDate,
                    y: predictionLow,
                    marker: {
                        size: 6,
                        fillColor: '#dc3545',
                        strokeColor: '#dc3545',
                        strokeWidth: 2,
                        shape: 'triangle'
                    }
                }
            );
            
            console.log(`Added annotations for prediction ${index + 1}:`, {
                xAxisLines: 2,
                yAxisLines: 2,
                points: 3,
                dateRange: `${new Date(createDate).toLocaleString()} to ${new Date(targetDate).toLocaleString()}`,
                priceRange: `$${predictionLow.toFixed(0)} - $${predictionHigh.toFixed(0)}`
            });
        });
        
        console.log('Final annotations created:', { points: points.length, xaxis: xaxis.length, yaxis: yaxis.length });
        console.log('Detailed annotations:', { points, xaxis, yaxis });
        return { points, xaxis, yaxis };
    };

    const annotations = createPredictionAnnotations();
    console.log('Annotations for ApexCharts:', annotations);

    var options = {
        chart: {
            type: 'candlestick',
            height: 294,
            toolbar: {
                show: false
            }
        },
        plotOptions: {
            candlestick: {
                colors: {
                    upward: MarketchartColors[0],
                    downward: MarketchartColors[1]
                }
            }
        },
        annotations: annotations,
        xaxis: {
            type: 'datetime'
        },
        yaxis: {
            tooltip: {
                enabled: true
            },
            labels: {
                formatter: function (value) {
                    return "$" + value;
                }
            }
        },
        tooltip: {
            shared: true,
            x: {
                formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
                    if (value) {
                        // value is in milliseconds but includes timezone offset from backend
                        // The backend does new Date(row.timestamp).getTime() which treats UTC as local time
                        // We need to subtract the timezone offset to get the actual UTC time
                        const tzOffsetMs = new Date().getTimezoneOffset() * 60 * 1000;
                        const correctedTime = value - tzOffsetMs;
                        
                        const date = new Date(correctedTime);
                        // Format as: Month/Day Hours:Minutes UTC (using UTC methods)
                        const month = date.getUTCMonth() + 1;
                        const day = date.getUTCDate();
                        const hours = String(date.getUTCHours()).padStart(2, '0');
                        const minutes = String(date.getUTCMinutes()).padStart(2, '0');
                        return `${month}/${day} ${hours}:${minutes} UTC`;
                    }
                    return value;
                }
            },
            y: {
                formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                    if (typeof value !== "undefined") {
                        return "$" + value.toFixed(2);
                    }
                    return value;
                }
            }
        }
    };
    return (
        <React.Fragment>
            <ReactApexChart dir="ltr"
                options={options}
                // series={series}
                series={series.length ? series : [{ data: [] }]}
                type="candlestick"
                height="294"
                className="apex-charts"
            />
        </React.Fragment>
    );
};

const WidgetsCharts = ({ seriesData, chartsColor }) => {
    const areachartlitecoinColors = [chartsColor];
    var options = {
        chart: {
            width: 130,
            height: 46,
            type: "area",
            sparkline: {
                enabled: true,
            },
            toolbar: {
                show: false,
            },
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            curve: "smooth",
            width: 1.5,
        },
        fill: {
            type: "gradient",
            gradient: {
                shadeIntensity: 1,
                inverseColors: false,
                opacityFrom: 0.45,
                opacityTo: 0.05,
                stops: [50, 100, 100, 100],
            },
        },
        colors: areachartlitecoinColors
    };
    return (
        <React.Fragment>
            <ReactApexChart dir="ltr"
                options={options}
                series={[...seriesData]}
                type="area"
                height="46"
                className="apex-charts"
            />
        </React.Fragment>
    );
};


export { PortfolioCharts, MarkerCharts, WidgetsCharts };